export const makeTwitterShareUrl = (url, text, hashtags=[]) => `https://twitter.com/share?url=${url}&text=${text}&via=pbstoryweaver&hashtags=${hashtags.join(',')}`;
export const makeFacebookShareUrl = url => `http://www.facebook.com/sharer.php?u=${url}`;
export const makeGooglePlusShareUrl = url => `https://plus.google.com/share?url=${url}`;
export const makeWhatsappShareUrl = (url, viewport) => viewport.medium ? `https://web.whatsapp.com/send?text=${url}` : `https://api.whatsapp.com/send?text=${url}`;
export const makeTelegramShareUrl = (url, text) => `https://telegram.me/share/url?url=${url}&text=${text}`;



// WEBPACK FOOTER //
// ./src/lib/social.js